/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (paymentTypes) => ({
    type: actions.CONNECTION_PAYMENT_TYPES_RECEIVE,
    payload: { paymentTypes },
});